import React, { useState } from "react";
import { TextField, Button, Box, Typography, Grid } from "@mui/material";
import axios from "axios";
import Swal from 'sweetalert2';
import "./Waitlist.css"; // For custom styling
import "./jupyton.css"; // For custom styling
import {DynamicLink} from '../Helper/HelperEnum'

const WaitlistForm = () => {
    const [formData, setFormData] = useState({ name: "", email: "", referral: "" });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSuccess = (title, text) => {
        Swal.fire({
          title: title || 'Success!',  // Default title is 'Success!' if not passed
          text: text || 'Your operation was completed successfully.',  // Default text
          icon: 'success',  // Success icon
          confirmButtonText: 'OK',
          customClass: {
            confirmButton: 'sweetalert-confirm-button', // Apply custom class to confirm button
          },
        });
      };
    
      // Handle error message
      const handleError = (title, text,confirmText) => {
        Swal.fire({
          title: title || 'Error!',  // Default title is 'Error!' if not passed
          text: text || 'Something went wrong. Please try again later.',  // Default text
          icon: 'error',  // Error icon
          confirmButtonText: confirmText|| 'Ok',
          customClass: {
            confirmButton: 'sweetalert-confirm-button', // Apply custom class to confirm button
          },
        });
      };

    const isFormValid = formData.name.trim() !== "" && formData.email.trim() !== "";

    const handleSubmit = async() => {
        //Get Token
        let jwtToken=""
        try{
        const tokenUrl = `${DynamicLink.RP_WL_API}/api/v1/whitelist/generate`;
        const responseToken = await axios.get(tokenUrl);
        jwtToken=responseToken.data;
        }
        catch (error) {
            console.log("handleSubmit: response: error",error)            
        }
          // Extract the JWT token from the response data
        //  const jwtToken = response.data.token;
        console.log("handleSubmit: jwtToken: ", jwtToken);
        console.log("Form Submitted", formData);
        const url = `${DynamicLink.RP_WL_API}/api/v1/whitelist/add`;
       // const token=DynamicLink.RP_WL_JWT_Token
        const data = {
          name: formData.name,
          email:formData.email,
          referralCode:formData.referral,
          createdBy:"Real protocol WhiteList"
        };
        const headers={
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwtToken}`, // Pass Bearer token
          }
    
        try {
            const response = await axios.post(url,data,
                {
                  headers:headers,
                }
              );
              console.log("Response Data:", response.data);
         if(response.data.status =="success"){
            handleSuccess('Registration Done', 'Great! You’re on our waitlist.');
            setFormData({ name: "", email: "", referral: "" });
        // alert("Added to whitelist");
         }else if (response.data.status =="fail"){
           // alert(response.data.message);
           if(response.data.message == "Email is already there"){
           handleError('Registration Failed', "This email address has been used.","Try Again");
           }else{
            handleError('Failed Operation', response.data.message);
           }
         }
        
        //   const response = await fetch(url, {
        //     method: "POST", // Specify the method
        //     headers: {
        //       "Content-Type": "application/json", // Set the content type
        //       "Authorization": `Bearer ${token}`, // Include Bearer token
        //     },
        //     body: JSON.stringify(data), // Send the data in the request body
        //   });
        //  console.log("handleSubmit: response: ",response)
        //   if (!response.ok) {
        //     throw new Error("Failed to add to whitelist");
        //   }
    
          const result = await response.json();
        
        } catch (error) {
            console.log("handleSubmit: response: error",error)
            console.log("handleSubmit: response:error.response",error.response)
            if(error.response &&  error.response.data && error.response.data.statusCode== 400){
           // alert(error.response.data.message);
          // alert(error.response.data.message);
           if(error.response.data.message =="Please provide a valid email address"){
            handleError('Registration Failed',"Please provide a valid email address.","Try Again");
            }else{
                handleError('Failed Operation',error.response.data.message);
            }
            }
        }
    }

    return (
        <Box className="waitlist-container">
            {/* Video Background */}
            <video autoPlay loop muted className="background-video">
                <source src="/background.mp4" type="video/mp4" />
            </video>

            {/* Content Box */}
            <Box className="content-box" >
                {/* Header Section with Logo and Social Icons */}
                <Grid container justifyContent="space-between" alignItems="center" mb={2}>
                    {/* Logo on the Left */}
                    <Grid item>
                        <img
                            src="/logo.png" /* Replace with your actual logo file path */
                            alt="Logo"
                            className="main-logo"
                        // style={{ }}
                        />
                    </Grid>

                    {/* Social Icons on the Right */}
                    <Grid item>
                        <Box display="flex" gap={2}>
                            {/* Social Media Icon Links */}
                            <a
                                href="https://x.com/realprotocolco" /* Replace with actual Twitter link */
                                target="_blank"
                                rel="noopener noreferrer"
                                className="social-link"
                            >
                                <img
                                    src="/x.png" /* Replace with Twitter icon path */
                                    alt="Twitter"

                                />
                            </a>
                            <a
                                href="https://discord.com/invite/s2szRV8HRW" /* Replace with actual Discord link */
                                target="_blank"
                                rel="noopener noreferrer"
                                className="social-link"
                            >
                                <img
                                    src="/discord.png" /* Replace with Discord icon path */
                                    alt="Discord"

                                />
                            </a>

                            <a
                                href="https://docsend.com/v/vkdpc/realprotocol" /* Replace with actual Instagram link */
                                target="_blank"
                                rel="noopener noreferrer"
                                className="social-link"
                            >
                                <img
                                    src="/deck.png" /* Replace with Instagram icon path */
                                    alt="Instagram"

                                />
                            </a>
                        </Box>
                    </Grid>
                </Grid>

                {/* Form Content */}
                <Typography color="white" className="site-description" pt={3} variant="h5" marginBottom={2} >
                    Are you real, anon? <br /> Join the #ProofOfHumanWork movement.
                </Typography>
                <Typography variant="h1" pt={3} className="site-title"
                >
                    WAITLIST
                </Typography>

                <Box className="form-container" pt={6}
                    sx={{
                        width: { xs: "90%", sm: "80%", md: "70%" }, // Responsive width
                        margin: "0 auto",
                    }}
                >
                    {/* Form Grid */}
                    <Grid container spacing={2}>
                        <Grid container spacing={2}>
                            {/* Name Field */}
                            <Grid item xs={12} sm={3}>
                                <Typography className="form-label">NAME*</Typography>
                            </Grid>
                            <Grid item xs={12} sm={9}>
                                <TextField
                                    variant="outlined"
                                    fullWidth
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    InputProps={{
                                        style: {
                                            height: "36px", /* Reduces the height */
                                            color: "white",
                                            border: "1px solid white",
                                            borderRadius: 8,
                                            padding: "5px 10px", /* Adjusts padding inside */
                                        },
                                    }}
                                />
                            </Grid>

                            {/* Email Field */}
                            <Grid item xs={12} sm={3}>
                                <Typography className="form-label">EMAIL*</Typography>
                            </Grid>
                            <Grid item xs={12} sm={9}>
                                <TextField
                                    variant="outlined"
                                    fullWidth
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    InputProps={{
                                        style: {
                                            height: "36px", /* Reduces the height */
                                            color: "white",
                                            border: "1px solid white",
                                            borderRadius: 8,
                                            padding: "5px 10px", /* Adjusts padding inside */
                                        },
                                    }}
                                />
                            </Grid>

                            {/* Referral Field */}
                            <Grid item xs={12} sm={3}>
                                <Typography className="form-label">REFERRAL</Typography>
                            </Grid>
                            <Grid item xs={12} sm={9}>
                                <TextField
                                    variant="outlined"
                                    fullWidth
                                    name="referral"
                                    value={formData.referral}
                                    onChange={handleChange}
                                    InputProps={{
                                        style: {
                                            height: "36px", /* Reduces the height */
                                            color: "white",
                                            border: "1px solid white",
                                            borderRadius: 8,
                                            padding: "5px 10px", /* Adjusts padding inside */
                                        },
                                    }}
                                />
                            </Grid>
                        </Grid>


                        {/* Submit Button */}
                        <Grid item xs={12} pt={3} display="flex" justifyContent="flex-end">
                            <Button
                                variant="contained"
                                disabled={!isFormValid}
                                onClick={handleSubmit}
                                // className="submit-button"
                                className={!isFormValid ? 'invalid-button' : 'submit-button'}
                            >
                                GET REAL
                            </Button>
                        </Grid>
                    </Grid>

                </Box>
                <Box>
                    {/* Mandatory Field Note */}
                    <Grid item xs={12} pt={8}>
                        <Typography
                            variant="caption"
                            align="right"
                            component="a"
                           // href="https://example.com" // Replace with your actual URL
                           // target="_blank"
                            rel="noopener noreferrer"
                            style={{
                                color: "white",
                                fontSize: "0.8rem",
                                fontFamily: "PPNeueMachina, sans-serif",
                                textDecoration: "none", // Ensures link look
                                display: "block", // Aligns to the right
                                textAlign: "right",
                                marginTop: "10px",
                                bottom: 0
                            }}
                        >
                            *mandatory field
                        </Typography>
                    </Grid>
                </Box>
            </Box>
        </Box>
    );
};

export default WaitlistForm;
